<template>
  <v-flex xs12 sm10 md8 lg6>
    <v-card class="pa-4">
      <v-flex xs12 pb-3 v-if="err">
        <v-alert :value="true" type="error">{{err}}</v-alert>
      </v-flex>
      <v-flex xs12 pb-3 v-if="success">
        <v-alert :value="true" type="success">{{success}}</v-alert>
      </v-flex>
      <v-form v-model="valid">
        <v-layout row wrap justify-space-between align-center>
          <v-flex xs12>
            <v-autocomplete
              :items="companies"
              :label="$lang.actions.selectCompany"
              v-model="callerIdServer.companyId"
              item-text="name"
              item-value="id"
              required
              :readonly="isEdit"
              :loading="companyLoading"
              :rules="[v => !!v || `${$lang.errors.missingCompany}`]"
            />
          </v-flex>
          <v-flex xs12>
            <v-text-field
              :label="$lang.labels.name"
              v-model="callerIdServer.name"
              required
              :rules="[v => !!v || `${$lang.errors.missingCallerIdName}`]"
            />
          </v-flex>
          <v-flex xs12 v-if="isEdit">
            <v-textarea
              id="key"
              :label="$lang.labels.key"
              v-model="callerIdServer.callerIdKey"
              auto-grow
              rows="1"
              :readonly="isEdit"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-space-between align-content-center class="mt-3">
          <v-btn 
            flat class="ml-0" 
            @click="$router.push({ name: 'callerIdServers' })">
            <v-icon>keyboard_arrow_left</v-icon>
            {{$lang.actions.close}}
          </v-btn>
          <div>
            <v-btn class="primary" v-if="isEdit" @click="copyKey">
              {{$lang.actions.copyKey}}
            </v-btn>
            <v-btn
              class="primary mx-0" 
              :disabled="!valid" 
              @click="submit">
              {{ isEdit ? $lang.actions.update : $lang.actions.create}}
            </v-btn>
          </div>
        </v-layout>
      </v-form>
    </v-card>
  </v-flex>
</template>

<script>
  export default {
    data: () => ({
      err: '',
      success: '',
      valid: false,
      isEdit: false,
      companyLoading: true,
      companies: [],
      callerIdServer: {
        companyId: null,
        name: null,
      },
    }),
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    methods: {
      init() {
        return new Promise((resolve) => {
          this.$http.get('company')
            .then((res) => {
              resolve()
              this.companyLoading = false;
              if (res.body.status === 'Success') {
                this.companies = res.body.companies;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve()
              this.companyLoading = false;
              this.err = err.body.statusText || err.body.message;
            });
        });
      },
      copyKey() {
        try {
          var copyText = document.getElementById('key');
          copyText.select();
          const success = document.execCommand('copy');
        } catch (e) {
          console.log(e);
        }
      },
      submit() {
        let url = this.isEdit ? `calleridserver/update/${this.$route.params.id}` : 'calleridserver/create';
        this.$http.post(url, this.callerIdServer)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.success = this.isEdit ? 'CallerID Server updated successfuly' : 'CallerID Server created successfuly';
              setTimeout(() => {
                if (this.isEdit) {
                  this.success = '';
                } else {
                  this.$router.push({ name: 'callerIdServers' });
                }
              }, 3000);
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
    },
    created() {
      this.init()
        .then(() => {
          if (this.$route.params.id) {
            this.isEdit = true;
            this.$http.get(`calleridserver/fetchbyid/${this.$route.params.id}`)
              .then((res) => {
                if (res.body.status === 'Success') {
                  this.callerIdServer = res.body.details;
                  return;
                }
                this.err = res.body.statusText
              }, (err) => {
                this.err = err.body.statusText || err.body.message;
              })
            }
        })
    },
  };
</script>


// WEBPACK FOOTER //
// CallerIdDetails.vue?4667c586